import { I } from '@angular/cdk/keycodes';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'app/common/toast-alert/toast.service';
import { FormulaData } from 'app/formula-details/formula-details.component';
import { GlobalsService } from 'app/globals-services/globals.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-update-cap',
  templateUrl: './update-cap.component.html',
  styleUrls: ['./update-cap.component.scss']
})
export class UpdateCAPComponent implements OnInit {
  correctiveActionPlan: FormGroup;
  dateToday: Date;
  uploadData: any;
  isSelfDeclaration: boolean = false;
  isAddCASNo: boolean = false;
  isSelfDeclarationUploaded: boolean = false;
  hazardousSubstances = [];
  alertMsgs = {};
  constructor(
    public dialogRef: MatDialogRef<UpdateCAPComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private _formBuilder: FormBuilder,
    private globalsService: GlobalsService,
    private toastService: ToastService,
    private translateService: TranslateService


  ) {

    this.fetchTranslations();

    this.translateService.onLangChange.subscribe(() => {
      this.fetchTranslations();
    });

    this.correctiveActionPlan = this._formBuilder.group({
      'remediation': [data.remediation, null],
      'action': [data.action, null],
      'substituteChemical': [data.substituteChemical, null],

      'deadline': [data.deadline, null],
      'cap_status': [data.cap_status ? 1 : 0, null],
    });
    this.uploadData = {
      masterId: data.masterid
    }
    this.dateToday = new Date();

    this.onRemidationChange({ value: data.remediation });
    if (data.selfDeclaration) {
      //this.isSelfDeclaration = true
      this.isSelfDeclarationUploaded = true;
    }

  }

  ngOnInit(): void {

  }

  fetchTranslations() {
    this.translateService
      .get('UPDATE_CAP_COMPONENT.MESSAGES')
      .subscribe((response) => {
        this.alertMsgs = response;
        // console.log(this.alertMsgs);
      });
  }



  Cancel() {
    this.dialogRef.close(null);
  }

  Save(data: any) {

    if (this.correctiveActionPlan.controls['cap_status'].value == 1 || this.correctiveActionPlan.valid) {

      // console.log(data.userghshazard_statement);
      let remediation = this.correctiveActionPlan.controls['remediation'].value
      let deadline = this.correctiveActionPlan.controls['deadline'].value
      let action = this.correctiveActionPlan.controls['action'].value


      if (remediation == undefined || remediation == null) {
        this.toastService.error("Please select remediation")
        return
      }

      if (deadline == undefined || deadline == null) {
        this.toastService.error("Please select deadline")
        return
      }

      

      if (remediation ==='Update' && (action==undefined || action==null) ) {
        this.toastService.error("Please select action")
        return
      }


      if (this.isAddCASNo && !this.isCasNumberValid()) {
        return;

      }


      this.http.put(this.globalsService.baseHref + '/updateCap',
        {

          'creatorID': data.creatorID,

          'remediation': remediation,
          'action': action,
          'deadline': deadline,
          'cap_status': this.correctiveActionPlan.controls['cap_status'].value,
          substituteChemical: this.correctiveActionPlan.controls['substituteChemical'].value,
          'id': data.id

        }).subscribe(
          () => {
            this.toastService.success("CAP information saved sucessfully", true)

            if (this.isAddCASNo)
              this.saveHazardSubstance();

            this.dialogRef.close(data);
            // setTimeout( () => {  this.dialogRef.close(data); }, 10000 );

          },
          (err) => {
            console.log(err);
            alert('Error: Data specific to chemical could not be saved!');
          });
    }

  }

  onRemidationChange(ev) {
    this.isAddCASNo = false
    this.isSelfDeclaration = false
    if (ev.value === "STeP Declaration Letter") {
      this.isSelfDeclaration = true
      //   this.isSelfDeclarationUploaded = false;
    }

    if (ev.value === "Add CAS Number(s)") {
      this.isAddCASNo = true;
      if (this.hazardousSubstances.length == 0) {
        this.getHazardousSubstance()
        // this.hazardousSubstances.push({ casNo: null, substanceName: null, concentration: null })
      }
    }

  }

  setViewChanges() {

  }


  addNewHazardousSubstance(casNo, substanceName, concentration) {
    this.hazardousSubstances.push({ casNo: casNo, substanceName: null, concentration: null })
  }


  getHazardousSubstance() {
    //console.info(this.data)

    this.http
      .get(
        environment.baseHref + '/getChemicalFormulation/' + this.data['creatorID'] + '/' + this.data['masterid']
      )
      .subscribe(
        (response: any) => {
          this.globalsService.hideSpinner();
          this.hazardousSubstances = []
          response['ingredients'].forEach(element => {
            this.hazardousSubstances.push({ id: element.id, casNo: element.casnr, substanceName: element.substanceName, concentration: element.percentage })

          });
          ;
          if (this.hazardousSubstances.length == 0) {
            this.hazardousSubstances.push({ casNo: null, substanceName: null, concentration: null })
          }
        },
        (error) => {
          this.globalsService.hideSpinner();
          this.toastService.error('Failed to update information');
        }
      );
  }

  saveHazardSubstance() {
    let hazardousSubstances = [];

    this.hazardousSubstances.forEach((element) => {
      if (element.casNo && element.substanceName && element.concentration) {


        hazardousSubstances.push({
          id: element.id,
          casnr: element.casNo,
          substanceName: element.substanceName,
          percentage: element.concentration,
          masterid: element.masterid
        });
      }
    });


    if (hazardousSubstances.length == 0) {
      //  this.toastService.error("Please check Substances Names/CAS No./Concentration")
      return;
    }





    this.globalsService.showSpinner();
    this.http
      .put(
        environment.baseHref + '/saveChemicalFormulation',
        {
          creatorID: this.data['creatorID'],
          //   formulaId: this.formulaId,

          masterid: Number(this.data['masterid']),
          msds_identifier: this.data['masterid'],
          newFormulation: hazardousSubstances,
          deletedFormulation: []
        }
      )
      .subscribe(
        (response: any) => {
          this.globalsService.hideSpinner();

          this.toastService.success(this.alertMsgs['CAS_NO_ADD_SUCCESS'], true)
        },
        (error) => {
          this.globalsService.hideSpinner();
          this.toastService.error('Failed to update information');
        }
      );
  }



  deleteHazardSubstance(index, element) {
    if (element.id) {
      this.globalsService.showSpinner();
      this.http
        .put(
          environment.baseHref + '/deleteChemicalHazardFormulation/' + element.id, null

        )
        .subscribe(
          (response: any) => {
            this.globalsService.hideSpinner();
            this.toastService.success(
              'Information updated successfully'
            );
            this.hazardousSubstances.splice(index, 1);

          },
          (error) => {
            this.globalsService.hideSpinner();
            this.toastService.error('Failed to update information');
          }
        );
    } else {

      this.hazardousSubstances.splice(index, 1);

    }


  }

  onUploadEvent(ev) {

    if (ev) {
      this.isSelfDeclarationUploaded = true
      this.toastService.success(this.alertMsgs['UPLOAD_SUCCESS'])

    }
  }


  isCasNumberValid() {
    let casErrorCount = 0
    this.hazardousSubstances.forEach((element) => {
      if (!this.isCASValid(element.casNo)) {

        ++casErrorCount;
      }
    })

    if (casErrorCount > 0) {
      this.toastService.error("Please enter valid CAS number.")
      return false;
    }

    return true;
  }
  isCASValid(casNo) {


    var regex = /^\d{2,7}[-]\d{2}[-]\d{1}$/
    return regex.test(casNo)
  }
}
